import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "./redux/leadStatusSagas";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import { BreakdownByMetric } from "./smartComponents/BreakdownByMetric";
import { DatePicker } from "./smartComponents/DatePicker";
import { UpdateBtns } from "./smartComponents/UpdateBtns";

import "./leadStatus.scss";

const LeadStatusModule = (props) => {
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.leadStatus.isLoading);
  const isUpdating = useSelector((state) => state.leadStatus.isUpdating);
  const initialRequest = useSelector((state) => state.leadStatus.initialRequest);

  useEffect(() => {
    if (!initialRequest) {
      dispatch(actionCreators.fetchCurrentUser(props));
    }
  }, []);

  return (
    <SectionToggle
      isLoading={isLoading}
      title="Lead Status"
      autoHeight
      content={
        <div id="lead-status">
          {props.showModule ? (
            <div id="module-date-filters">
              <div id="override-edit-selection-bar" className="edit-selections-bar">
                <div className="filters-wrapper">
                  <DatePicker />
                </div>

                <UpdateBtns />
              </div>

              {isUpdating ? <LoadingAnimation text="Updating data..." /> : <BreakdownByMetric />}
            </div>
          ) : (
            <div className="error">
              Not Available in All Stores View, when user selected more than 100 stores
            </div>
          )}
        </div>
      }
    />
  );
};

export default LeadStatusModule;
